import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  OnInit,
} from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import {
  AccordionComponent,
  getIconForProduct,
  LogoComponent,
  TabBarComponent,
  TabComponent,
  TagComponent,
  TypographyComponent,
} from '@hyperkit';
import { HuntContextService } from '../../../../pages/hunt/services/hunt-context.service';
import { CommonModule } from '@angular/common';
import { Hunt } from '@cyborg-monorepo/hunter/common';
import { HuntEditorComponent } from '../../../../pages/hunt/details/components/hunt-editor';
import { toSignal } from '@angular/core/rxjs-interop';
import { map, tap } from 'rxjs/operators';
import { defer } from 'rxjs';
import { ReportQueryHeaderComponent } from '../../report-query-header/report-query-header.component';
import { ReportQueryComponent } from '../../report-query/report-query.component';
import { ReportTextBlockComponent } from '../../hunt-final-report/report-text-block/report-text-block.component';

@Component({
  standalone: true,
  selector: 'edit-report-hunt-package',
  imports: [
    CommonModule,
    RouterModule,
    TypographyComponent,
    TagComponent,
    ReportQueryHeaderComponent,
    ReportTextBlockComponent,
    ReportQueryComponent,
    LogoComponent,
    AccordionComponent,
    HuntEditorComponent,
    TabComponent,
    TabBarComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './edit-report-hunt-package.component.html',
  styleUrls: ['edit-report-hunt-package.component.scss'],
})
export class EditReportHuntPackageComponent {
  readonly huntContext = inject(HuntContextService);
  private readonly route = inject(ActivatedRoute);

  readonly envs = this.huntContext.editor.getAllEnvironments;

  readonly packageId = toSignal(
    defer(() =>
      this.route.paramMap.pipe(map((params) => params.get('packageId'))),
    ),
    { initialValue: null },
  );

  constructor() {
    const resolvedHunt = this.route.snapshot.data['hunt'] as Hunt | null;

    if (resolvedHunt) {
      this.huntContext.state.updateHunt(resolvedHunt);
      this.huntContext.editor.load(resolvedHunt);
    }
  }

  public onDescriptionChange(newDescription: string): void {
    const packageId = this.packageId();
    const update = { description: newDescription };
    this.huntContext.editor.patchPackageById(packageId, update);
    this.huntContext.editor.submit();
  }

  public onMitigationRecommendationsChange(
    newMitigationRecommendations: string,
  ): void {
    const packageId = this.packageId();
    const update = {
      response_actions: {
        mitigation_recommendations: newMitigationRecommendations,
      },
    };
    this.huntContext.editor.patchPackageById(packageId, update);
    this.huntContext.editor.submit();
  }

  getIconForProduct = getIconForProduct;
}
